// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:19:42

export default {
  "id": "fairy-wingerella",
  "slug": "fairy-wingerella",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/4ab1284e27394b1c95d210248e2ba752-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/4ab1284e27394b1c95d210248e2ba752/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Fairy Wingerella",
      "description": "Soar through the skies with Fairy Wingerella in this action-packed arcade adventure! Meet Wingerella, a fearless and ambitious fairy striving to become the most powerful of her kind. Embark on her magical journey, navigating enchanting skies and conquering exciting challenges. With captivating visuals and engaging gameplay, this adventure promises endless fun and excitement!",
      "instructions": "Master the art of flight with Wingerella by using your keyboard or touch screen controls. Steer clear of obstacles while gathering power-ups to enhance her strength and magical abilities. Each level introduces fresh challenges and trials, pushing you to soar higher and achieve greatness!",
      "genres": [
        "Casual"
      ],
      "tags": [
        "arcade",
        "fairy",
        "platformer",
        "runner"
      ]
    },
    "zh-CN": {
      "title": "精灵翼尔拉",
      "description": "与仙翼艾拉翱翔于天空，在这款充满动作的街机冒险中！遇见艾拉，一位无畏且雄心勃勃的精灵，致力于成为她同类中最强大的存在。踏上她的魔法之旅，穿梭于迷人的天空，征服令人兴奋的挑战。凭借引人入胜的视觉效果和引人入胜的游戏玩法，这次冒险承诺带来无尽的乐趣和兴奋！",
      "instructions": "掌握Wingerella飞行艺术，通过键盘或触摸屏控制操作。避开障碍物，收集能量提升她的力量和魔法能力。每个关卡都带来新的挑战和考验，推动你飞得更高，成就非凡！",
      "genres": [
        "休闲"
      ],
      "tags": [
        "街机",
        "童话",
        "平台",
        "跑酷"
      ]
    },
    "zh-TW": {
      "title": "仙子翼爾拉",
      "description": "與仙翼艾拉翱翔天際，這是一款充滿動作的街機冒險遊戲！認識艾拉，一位無畏且雄心勃勃的小仙子，努力成為她種族中最強大的存在。啟程於她的魔法旅程，穿梭於迷人的天際，征服刺激的挑戰。擁有迷人的視覺效果和引人入勝的遊戲玩法，這場冒險保證無盡的樂趣與刺激！",
      "instructions": "掌握Wingerella飛行藝術，透過鍵盤或觸控屏控制。避開障礙，收集增強她力量和魔法能力的道具。每個關卡都帶來新的挑戰和試驗，推動你翱翔更高，達成偉大！",
      "genres": [
        "休闲"
      ],
      "tags": [
        "電玩",
        "仙俠",
        "平台遊戲",
        "跑酷遊戲"
      ]
    },
    "zh-HK": {
      "title": "仙女維吉拉",
      "description": "乘著仙翼艾拉翱翔天際，參與這場充滿動作的街機冒險！認識艾拉，一位無畏而雄心勃勃的小仙子，努力成為她種族中最強大的一員。啟程於她的魔法之旅，穿梭於迷人的天際，征服刺激的挑戰。這場冒險擁有吸引人的視覺效果和引人入勝的遊戲體驗，保證帶來無窮的樂趣與刺激！",
      "instructions": "掌握Wingerella飛行藝術，透過鍵盤或觸控螢幕操作。避開障礙物，收集提升力量和魔法能力的物品。每個關卡都帶來新挑戰和考驗，推動你飛得更高，成就偉大！",
      "genres": [
        "隨機"
      ],
      "tags": [
        "街機",
        "仙子",
        "平台遊戲",
        "跑酷遊戲"
      ]
    },
    "ja": {
      "title": "フェアリーウィンガエラ",
      "description": "空を自由自在に舞い上がれ、アクション満載のアーケードアドベンチャーでフェアリーウィンガエラと共に！無畏で野心に満ちたフェアリーウィンガエラに出会い、彼女が自分たちの種の中で最も強力になることを目指す冒険に参加しよう。魔法の空を進み、楽しい挑戦を乗り越えよう。魅力的なビジュアルと魅力的なゲームプレイで、このアドベンチャーは無限の楽しみと興奮を約束します！",
      "instructions": "Wingerellaを使用して、キーボードまたはタッチスクリーンコントロールを使って飛行の芸術をマスターしましょう。障害物を避けながら、パワーアップを集め、彼女の力と魔法の能力を高めましょう。各レベルで新しい挑戦と試練が登場し、さらに高く飛び、偉大さを達成するよう駆り立てられます！",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "アーケード",
        "ファイアリー",
        "パラレルプレイヤー",
        "ランナー"
      ]
    },
    "ko": {
      "title": "페리 와잉겔라",
      "description": "하늘을 넘나드는 Fairy Wingerella의 액션 가득한 아케이드 모험을 즐겨보세요! 용감하고 목표를 가진 Wingerella 공주를 만나세요. 그녀의 마법의 여정에 올라타고, 매혹적인 하늘을 탐험하고 흥미진진한 도전을克服하세요. 매력적인 시각적 요소와 흥미로운 게임플레이로, 이 모험은 끝없는 재미와 설렘을 약속합니다!",
      "instructions": "Wingerella를 사용하여 키보드나 타ッチ스크린 조이스틱을 통해 비행의 기술을 익혀보세요. 장애물을 피하면서 파워업을 모아 그녀의 강력한 능력과 마법적 능력을 강화하세요. 각 레벨은 새로운 도전과 시험을 제공하여 더 높이 치솟고 위대함을 달성하도록 도와줍니다!",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "아케이드",
        "페어리",
        "플랫폼 게임",
        "런너"
      ]
    },
    "fr": {
      "title": "Fée Wingerella",
      "description": "Voler à travers les cieux avec Fairy Wingerella dans cette aventure d'arcade pleine d'action ! Rencontrez Wingerella, une fée osée et ambitieuse qui rêve de devenir la plus puissante de son espèce. Embarkez sur son voyage magique, naviguant dans des cieux enchantés et conquérant des défis captivants. Avec des visuels captivants et un gameplay captivant, cette aventure promet un amusement et une excitation sans fin !",
      "instructions": "Maitrisez l'art du vol avec Wingerella en utilisant vos commandes au clavier ou sur l'écran tactile. Évitez les obstacles tout en collectant des power-ups pour renforcer sa force et ses capacités magiques. Chaque niveau introduit de nouveaux défis et épreuves, vous poussant à voler plus haut et à accomplir des grandes choses !",
      "genres": [
        "Occasionnel"
      ],
      "tags": [
        "arcade",
        "féerie",
        "plate-forme",
        "runner"
      ]
    }
  }
};
